{
    "warning": "DİKKAT!",
    "message": "Anlamadığınız kodu girmeyin veya yapıştırmayın.\nBu konsolu kullanmak, saldırganların sizi taklit etmesine ve Self-XSS adlı bir saldırı kullanarak bilgilerinizi çalmasına izin verebilir."
}
